import { AbstractControl, AsyncValidatorFn, ValidatorFn } from '@angular/forms';

export type ComplexErrorMessage = (value: any) => string;

export enum ValidationType {
  Min = 'min',
  Max = 'max',
  MinLength = 'minlength',
  MaxLength = 'maxlength',
  Required = 'required',
  RequiredTrue = 'requiredTrue',
  Email = 'email',
  Pattern = 'pattern',
  NullValidator = 'nullValidator',
  Custom = 'custom',
}

export type ValidationMessage = (
  control: AbstractControl,
  ...value: any
) => string;

export type NibtravelValidator = (
  control: AbstractControl,
  value?: any
) => ValidatorFn | AsyncValidatorFn;

export interface ICustomValidator {
  name: string;
  validator: NibtravelValidator;
}

export interface IFormFieldValidation {
  /**
   * @description
   * Property that defines the type of validation to be added.
   * Available types matches what Angular provides.
   */
  type: ValidationType;

  /**
   * @description
   * Some validations accepts a parameter.
   * Set your parameter based on what the Angular ValidatorFn offers.
   */
  parameter?: any;

  /**
   * @description
   * When defining a custom validation, set the custom validation name so we can get the proper error message.
   */
  custom?: ICustomValidator;

  /**
   * @description
   * Use the message if you want to override the default value set by the error object.
   * e.g.:
   *
   * The custom validation returns { someErrorName: 'Houston, we have a problem!' }
   * Should you leave this property null/undefined, the error message should be 'Houston, we have a problem!'
   */
  message?: ValidationMessage;

  /**
   * Flag to tell the validator handler directive that this is an async validator.
   * With this flag, it automatically assumes custom exists.
   *
   * @type {boolean}
   * @memberof IFormFieldValidation
   */
  async?: boolean;
}
